module.exports = __webpack_public_path__ + "img/kk-back.2e3e83c9.png";